import { Component } from '@angular/core';

@Component({
  selector: 'app-info-icon',
  styleUrls: ['./center.style.css'],
  template: `
    <div class="center">

    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M6.99984 13.3337C10.4976 13.3337 13.3332 10.4981 13.3332 7.00033C13.3332 3.50252 10.4976 0.666992 6.99984 0.666992C3.50203 0.666992 0.666504 3.50252 0.666504 7.00033C0.666504 10.4981 3.50203 13.3337 6.99984 13.3337ZM6.1665 3.83366C6.1665 3.37342 6.5396 3.00033 6.99984 3.00033C7.46007 3.00033 7.83317 3.37342 7.83317 3.83366V7.16699C7.83317 7.62723 7.46007 8.00033 6.99984 8.00033C6.5396 8.00033 6.1665 7.62723 6.1665 7.16699V3.83366ZM7.99984 10.0003C7.99984 10.5526 7.55212 11.0003 6.99984 11.0003C6.44755 11.0003 5.99984 10.5526 5.99984 10.0003C5.99984 9.44804 6.44755 9.00033 6.99984 9.00033C7.55212 9.00033 7.99984 9.44804 7.99984 10.0003Z" fill="white" />
    </svg>
  
    </div>`
})
export class InfoIconComponent {}
